import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Trash } from "iconsax-react";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [items, setItems] = useState([
    {
      testProperties: "",
      specification: "",
    },
  ]);
  const [deletedItems, setDeletedItems] = useState([]);

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  useEffect(() => {
    getProductList();
  }, []);

  const getProductList = () => {
    utils
      .callAPI("get", `/Product/list`)
      .then((res) => {
        setProductOptions(res);
      })
      .catch(() => setProductOptions([]));
  };

  const options = productOptions?.result?.map((prod) => ({
    value: prod.id,
    label: prod.productCode
      ? `${prod.product_name} - (${prod.productCode}) - ${prod?.size} ${prod?.unit?.toUpperCase() || ""}`
      : prod.product_name,
    productCode: prod.productCode,
  }));

  const handleProductSelection = (selected) => {
    setSelectedProduct(selected);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index][field] = value;
    setItems(newItems);
  };

  const addItem = () => {
    setItems([
      ...items,
      {
        testProperties: "",
        specification: "",
      },
    ]);
  };

  useEffect(() => {
    if (isSubmit) {
      const transformedData = transformItems(items);
      const deleteItem = transformItems(deletedItems);
      var bodyFormData = new FormData();
      if (props.rowData && Object.keys(props.rowData).length > 0) {
        bodyFormData.append("id", props.rowData.id);
      }
      bodyFormData.append("product_id", selectedProduct?.value);
      bodyFormData.append("specification", JSON.stringify(transformedData));
      bodyFormData.append("delete_id", JSON.stringify(deleteItem));
      utils
        .callAPI("post", `/production/specification/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
            setIsSubmit(false);
          }
        })
        .catch((err) => {});

      setIsSubmit(false);
    }
  }, [isSubmit]);

  const transformItems = (data) => {
    const transformedData = data.map((info) => ({
      id: info.id ? info.id : 0,
      properties: info.testProperties,
      specification: info.specification,
    }));

    return transformedData;
  };

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      setisEdit(true);
      setSelectedProduct({
        value: props.rowData?.product_id,
        label: `${props.rowData?.product_name}`,
      });

      const transformedItems = props.rowData.specify.map((item) => ({
        id: item.id,
        testProperties: item?.properties,
        specification: item?.specification,
      }));

      setItems(transformedItems);
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const handleDeleteRow = (index) => {
    const updatedItems = [...items];
    const deletedItem = updatedItems[index];
    // Filter out the item to be deleted
    const newItems = updatedItems.filter((_, i) => i !== index);
    setItems(newItems);
    if (isEdit) {
      setDeletedItems((prevDeletedItems) => [...prevDeletedItems, deletedItem]);
    }
  };

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header>
          <h4>{isEdit ? "Edit" : "Add"}</h4>
          <div className="card-header-action">
            <Link className="btn btn-underline me-2" onClick={handleBackClick}>
              Back
            </Link>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mt-3">
                  <RB.FloatingLabel
                    controlId="productName"
                    className="floating-label-fancy"
                  >
                    <Select
                      options={options}
                      value={selectedProduct}
                      onChange={handleProductSelection}
                      placeholder="Select Product Name"
                      className="bom-productName-select"
                      classNamePrefix="select"
                      isClearable
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>
            <RB.Row className="mt-4">
              <RB.Col>
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Test Properties</th>
                        <th>Specification</th>
                        {items.length > 1 && <th></th>}
                      </tr>
                    </thead>
                    <tbody>
                      {items.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <RB.Form.Control
                              type="text"
                              value={item.testProperties}
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "testProperties",
                                  e.target.value
                                )
                              }
                              placeholder="Enter Test Properties"
                              required
                            />
                          </td>
                          <td>
                            <RB.Form.Control
                              type="text"
                              value={item.specification}
                              onChange={(e) =>
                                handleItemChange(
                                  index,
                                  "specification",
                                  e.target.value
                                )
                              }
                              placeholder="Enter Specification"
                              required
                            />
                          </td>
                          {items.length > 1 && (
                            <td className="p-1">
                              <RB.Button
                                className="btn-flat"
                                title="Delete"
                                onClick={() => handleDeleteRow(index, item.id)}
                              >
                                <Trash />
                              </RB.Button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                    <RB.Button
                      variant="primary"
                      size="sm"
                      onClick={addItem}
                      className="mt-2"
                    >
                      Add New
                    </RB.Button>
                  </table>
                </div>
              </RB.Col>
            </RB.Row>
            <div className="text-end mt-3">
              <RB.Button variant="primary" type="submit">
                Submit
              </RB.Button>
            </div>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
